/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentRunTTLRefreshRequest {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentRunTTLRefreshRequest.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentRunTTLRefreshRequest>): WellArchitectedFrameworkAssessmentRunTTLRefreshRequest {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentRunTTLRefreshRequest(), model);
        WellArchitectedFrameworkAssessmentRunTTLRefreshRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentRunTTLRefreshRequest>): WellArchitectedFrameworkAssessmentRunTTLRefreshRequest {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentRunTTLRefreshRequest.newInstance(<WellArchitectedFrameworkAssessmentRunTTLRefreshRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentRunTTLRefreshRequest) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentRunTTLRefreshRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentRunTTLRefreshRequest): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentRunTTLRefreshRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Service account ID to perform TTL refresh
     */
    service_account_id: string;

    policy_uris: Array<string>;

}
